export default __webpack_public_path__ + "media/zurb/img/work/wtsbooks/wtsbooks-hero-bg-6e160d835c2c5d5804680fa4a70bc9c7.png";